import React from 'react'

import { SftpSetting } from 'types/GlobalSource'

import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

import { useActiveSourcesActions } from 'redux/actions/DataPlatform/connections/ActiveSources'

interface ResetPasswordDialogProps {
  onClose: () => void
  open: boolean
  sftpSetting: SftpSetting
}

const ResetPasswordDialog = (props: ResetPasswordDialogProps) => {
  const { onClose, open, sftpSetting } = props

  const { tryResetPassword } = useActiveSourcesActions()

  return (
    <SimpleDialog
      actions={
        <>
          <Button onClick={onClose} variant="text">
            Avbryt
          </Button>
          <Button
            onClick={() => {
              tryResetPassword(sftpSetting.attributes.active_source_id, {
                data: { id: sftpSetting.id }
              })
              onClose()
            }}
          >
            Generera
          </Button>
        </>
      }
      onClose={onClose}
      open={open}
      title="Generera nytt lösenord"
    >
      <Text>
        Är du säker på att du vill generera ett nytt lösenord? Det påverkar alla
        andra som använder samma konto mot SFTP-servern.
      </Text>
    </SimpleDialog>
  )
}

export default ResetPasswordDialog
